import { ApiClient } from '../redux/models/src';
import packageJson from '/package.json';

const ENV = 'prod';
const API_URL = 'https://backoffice.service.perplay.io/';
const API_CLIENT = new ApiClient(API_URL);
const SESSION_EXPIRATION_TIME = 1000 * 60 * 60;
const SESSION_ALARM_TIME = 1000 * 60;
const VERSION = packageJson.version;

const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyDdGQ7eig3JZNVSRm0_mkwndaCEnAaXsQM',
  authDomain: 'perplaylive.firebaseapp.com',
  databaseURL: 'https://perplaylive-default-rtdb.firebaseio.com',
  projectId: 'perplaylive',
  storageBucket: 'perplaylive.appspot.com',
  messagingSenderId: '829874382571',
  appId: '1:829874382571:web:a1d4c13901972e2868c0ae',
  measurementId: 'G-2MW8CVW252',
};

const TOKEN_CONTRACT_ADDRESS = {
  xper: '0xd420583dd2f1e53c41c3433be72b30202f5e51a3',
  per: '0x3f7f123BaB1fD545aa201194f628E933413fFFD7',
  arb: '0x912CE59144191C1204E64559FE8253a0e49E6548',
  nft: '0xDBF4F55ea7375229572f12a7eAF8D4865c15F49d',
};

const PAGE_OPTION_URL =
  'https://script.google.com/macros/s/AKfycbySM69b-eKtIdWhV0eThn8yL-vBIthD-F4VM6fMNsbhCmwzLcJUj8gKmU4AS-f2lwi3IQ/exec';

const STRING_TABLE_URL =
  'https://script.google.com/macros/s/AKfycbwxjy3BIBdNRT7Zn5TxMlOPHoZhFmMr9hxlslMWCVbFav6s57vofWjw1O-Roc8Fkgthaw/exec';

const BACK_OFFICE_STRING_TABLE_URL =
  'https://script.google.com/macros/s/AKfycbxpKSRfrJr9VsZZ7Ncbv_L9diWTnRYevSEGC9vZWLtm5d1NX3WpLz4FBesCbUqwUcUHYw/exec';

const HVH_NETWORK_URL ='https://ctz.havah.io/api/v3';

const BRIDGE_API_URL = 'https://www.perflex.io';

// Arbitrum 체인 파라미터 설정
const ARBITRUM_CHAIN = {
  chainId: 42161,
  chainName: 'Arbitrum One',
  nativeCurrency: {
    name: 'ETH',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: ['https://arb1.arbitrum.io/rpc'],
  blockExplorerUrls: ['https://arbiscan.io/'],
};

const PROD_CONFIG = {
  API_URL,
  API_CLIENT,
  SESSION_EXPIRATION_TIME,
  SESSION_ALARM_TIME,
  FIREBASE_CONFIG,
  TOKEN_CONTRACT_ADDRESS,
  VERSION,
  ENV,
  PAGE_OPTION_URL,
  STRING_TABLE_URL,
  BACK_OFFICE_STRING_TABLE_URL,
  HVH_NETWORK_URL,
  BRIDGE_API_URL,
  ARBITRUM_CHAIN
};
export default PROD_CONFIG;
